import { Colors } from '@ab-core/colors';
import { FormElementHeight } from '@ab-core/forms';
import { RADIUS } from '@ab-core/radius';
import styled from 'styled-components';

export const CounterWrapper = styled.div`
    display: grid;
    border: 1px solid ${Colors.gray70};
    border-radius: ${RADIUS.MINIMAL};
    overflow: hidden;

    height: 40px;
    grid-template-columns: ${FormElementHeight.Normal} 1px auto 1px ${FormElementHeight.Normal};

    & .ab-input,
    & .ab-input:focus,
    & .ab-input:disabled {
        border: none;
        border-radius: 0;
        text-align: center;
        margin-top: -1px;
    }
    & .ab-button {
        border-radius: 0;
        margin-top: -1px;
    }
`;

export const Hyphen = styled.div`
    height: 100%;
    background: ${Colors.gray70};
`;
